import { useLocation } from 'react-router-dom';
import { usePageTitle } from '../hooks/usePageTitle';
import { titleForPath } from '../lib/pageTitles';

/**
 * Titre d'onglet dynamique selon la page courante — « <Page> — Hélios ».
 * Centralisé ici (plutôt que dans chaque page) pour éviter de modifier des
 * dizaines de composants. Le mapping route → libellé vit dans lib/pageTitles
 * (sans dépendance au router, pour être testable isolément).
 */
export default function PageTitleManager() {
  const { pathname } = useLocation();
  usePageTitle(titleForPath(pathname));
  return null;
}
